/**
 * Two-letter uppercase monogram from a display name: the first letters of the
 * first two words, both letters of a single word, or '?' when empty.
 * "Aime Skincare" -> "AS", "Madonna" -> "MA", "" -> "?".
 */
export const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};
